// extracted by mini-css-extract-plugin
module.exports = {"container":"Duration_container__2ZJTd","header-container":"Duration_header-container__Ikfnl","title":"Duration_title__Hpfgg"};